import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useInterval from '../../../hooks/useInterval';
import * as styles from './styles/styles.module.scss';

const RotatingHero = ({ images, className, duration, buttonContainerStyle, children }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [delay, setDelay] = useState(duration);

  const handleSlideClick = index => {
    // pause or restart image rotation
    setCurrentImageIndex(index);
    setPaused(!paused);
    setDelay(paused ? duration : null);
  };

  const renderSlideButtons = () => (
    <div className={styles.slideButtons} style={buttonContainerStyle}>
      {images.map((image, index) => {
        const progressSpanStyle = {};
        const innerSpanClassNames = [];

        if (index < currentImageIndex) {
          innerSpanClassNames.push(styles.slideButtonSpanComplete);
        } else if (index === currentImageIndex) {
          innerSpanClassNames.push(styles.slideButtonSpanActive);
          progressSpanStyle.animationDuration = `${duration}ms`;
          progressSpanStyle.animationPlayState = `${paused ? 'paused' : 'running'}`;
        }

        return (
          <button
            alt={`show slide ${index + 1}`}
            key={image.alt}
            type="button"
            className={styles.slideButton}
            onClick={() => handleSlideClick(index)}
          >
            <span className={styles.slideButtonSpan}>
              <span className={classNames(innerSpanClassNames)} style={progressSpanStyle} />
            </span>
          </button>
        );
      })}
    </div>
  );

  useInterval(() => {
    let nextIndex = currentImageIndex + 1;

    if (nextIndex === images.length) {
      nextIndex = 0;
    }

    setCurrentImageIndex(nextIndex);
    setDelay(duration);
  }, delay);

  return (
    <div className={`${className} ${styles.container}`}>
      {images.map((image, index) => {
        return (
          <picture className={classNames(styles.picture, index !== currentImageIndex && styles.none)} key={image.w2800Jpg}>
            <source media="(max-width: 768px)" srcSet={image.w750Avif} type="image/avif" />
            <source media="(max-width: 768px)" srcSet={image.w750Jpg} type="image/jpg" />
            <source srcSet={image.w2800Avif} type="image/avif" />
            <source srcSet={image.w2800Jpg} type="image/jpg" />
            <img alt={image.alt} src={image.w2800Jpg} className={styles.heroImage} />
          </picture>
        );
      })}
      <div className={styles.opacCover} />
      {children}
      {renderSlideButtons()}
    </div>
  );
};

RotatingHero.propTypes = {
  buttonContainerStyle: PropTypes.object,
  className: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.object).isRequired
};

RotatingHero.defaultProps = {
  buttonContainerStyle: {}
};

export default RotatingHero;
